import { render, staticRenderFns } from "./LocalCreation.vue?vue&type=template&id=b4508952&"
import script from "./LocalCreation.vue?vue&type=script&lang=js&"
export * from "./LocalCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4508952')) {
      api.createRecord('b4508952', component.options)
    } else {
      api.reload('b4508952', component.options)
    }
    module.hot.accept("./LocalCreation.vue?vue&type=template&id=b4508952&", function () {
      api.rerender('b4508952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/places/LocalCreation.vue"
export default component.exports